import Marionette from 'backbone.marionette';
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import _ from 'underscore';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-ide-settings.hbs';

    var globalCh = Radio.channel('global');
    var ga = globalCh.request('app_options', 'ga_account');

    var IDESettingsView = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        ui: {
            tabSize: '#tab-size',
            theme: '#ide-theme'
        },
        events: {
            'submit form': 'onSubmit',
        },
        initialize: function() {
            this.destroyOnClose();
        },
        onRender: function() {
            this.ui.tabSize.val(this.model.get('tabSize'));
            this.ui.theme.val(this.model.get('theme'));
        },
        onSubmit: function(e) {
            e.preventDefault();

            this.model.set('tabSize', parseInt(this.ui.tabSize.val(), 10));
            this.model.set('theme', this.ui.theme.val());
            if (ga) {
                window.ga('send', 'event', 'codeEditor', 'Changed Settings', this.model.get('tabSize') + ' ' + this.model.get('theme'));
            }

            if (!this.model.get('tabSize')) {
                this.model.set('tabSize', 4);
            }

            this.model.save({}, {
                success: _.bind(function() {
                    this.closeDialog();
                }, this),
                error: _.bind(function(model, response, options) {
                    this.showAlert('error', 'An unknown error occurred');
                    console.error(response.responseText);
                }, this)
            });
        },
    });
    export default IDESettingsView;

